import {Cureus} from '../Cureus';

Cureus.AdminInvoices = {}

//= require_tree ./AdminInvoices